import React from "react";
import { PhoneCall } from "lucide-react";
import { Link } from "react-router-dom";

const queryicon = "https://cdn-icons-png.flaticon.com/128/6728/6728469.png";
const complainicon = "https://cdn-icons-png.flaticon.com/128/1253/1253778.png";

const MainHeaderPage = () => {
  return (
    <div className="bg-[#0B1F33] border-b border-white/10">
      <div className=" px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-3 lg:gap-6 py-2.5">
          {/* HELPLINE */}
          <a
            href="tel:8448341881"
            className="flex items-center gap-2 text-amber-400 hover:text-white transition-colors duration-300 shrink-0"
          >
            <PhoneCall size={14} className="animate-pulse shrink-0" />

            <span className="hidden sm:inline text-[10px] uppercase tracking-[0.15em] font-medium">
              Helpline
            </span>

            <span className="whitespace-nowrap text-[13px] font-semibold tracking-[0.05em]">
              844-834-1881
            </span>
          </a>

          {/* MARQUEE */}
          <div className="hidden md:flex flex-1 min-w-0 overflow-hidden mx-6">
            <div className="flex whitespace-nowrap animate-marquee gap-12 text-white text-xs lg:text-sm font-medium">
              <span>🔒 सुरक्षा 24/7, सुरक्षा हर वक़्त हर जगह</span>
              <span>🔒 सुरक्षा 24/7, सुरक्षा हर वक़्त हर जगह</span>
              <span>🔒 सुरक्षा 24/7, सुरक्षा हर वक़्त हर जगह</span>
            </div>
          </div>

          {/* LINKS */}
          <div className="flex flex-wrap items-center justify-center gap-x-3 sm:gap-x-5 gap-y-2 text-[10px] sm:text-[11px] uppercase tracking-[0.08em] sm:tracking-[0.12em] font-semibold text-white/90 shrink-0">
            <Link
              to="/contact"
              className="hover:text-amber-400 transition-colors duration-300"
            >
              Contact
            </Link>

            <span className="hidden sm:block text-white/20">•</span>

            <Link
              to="/complaint"
              className="flex items-center gap-1.5 hover:text-amber-400 transition-colors duration-300"
            >
              <img
                src={complainicon}
                alt="Complaint"
                className="w-3.5 h-3.5 object-contain"
              />
              <span>Complaint</span>
            </Link>
            <span className="hidden sm:block text-white/20">•</span>

            <Link
              to="/product-inquiry"
              className="flex items-center gap-1.5 hover:text-amber-400 transition-colors duration-300"
            >
              <img
                src={queryicon}
                alt="/product-inquiry"
                className="w-3.5 h-3.5 object-contain"
              />
              <span>Product Inquiry</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainHeaderPage;
